var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNobookmarkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 24.9911V2.90776C0.5 2.27484 0.706598 1.77228 1.11444 1.36444C1.52228 0.956598 2.02484 0.75 2.65776 0.75H17.0842C17.7171 0.75 18.2197 0.956598 18.6275 1.36444C19.0353 1.77228 19.2419 2.27484 19.2419 2.90776V24.9911L10.0683 21.051L9.87097 20.9663L9.67365 21.051L0.5 24.9911Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNobookmarkBlack);
export default __webpack_public_path__ + "static/media/nobookmark_black.03a4867827dfa2b88e4038c0e5413a89.svg";
export { ForwardRef as ReactComponent };